import React, { ReactNode } from 'react'

import { bemJoin } from 'bem-join'
import classNames from 'classnames'

import './InputBox.scss'

/** @deprecated Use InputBase instead. Retired once Select and remaining consumers migrate. */
export type InputBoxProps = {
  icon?: ReactNode
  control: ReactNode
  actions?: ReactNode
  size?: 'sm' | 'md' | 'lg'
  color?: 'primary' | 'secondary' | 'neutral'
  variant?: 'ghost' | 'quiet' | 'outlined'
  className?: string
}

export const inputBoxBem = bemJoin('input-box')

/** @deprecated Use InputBase instead. Retired once Select and remaining consumers migrate. */
export const InputBox = ({
  icon,
  control,
  actions,
  size = 'md',
  color = 'neutral',
  variant = 'outlined',
  className
}: InputBoxProps) => {
  return (
    <div
      className={classNames(
        inputBoxBem({
          [size]: true,
          [color]: true,
          [variant]: true,
          'has-icon': !!icon,
          'has-actions': !!actions
        }),
        className
      )}
    >
      {icon && <span className={inputBoxBem('icon')}>{icon}</span>}
      {actions && <span className={inputBoxBem('actions')}>{actions}</span>}
      {control}
    </div>
  )
}
